import React from 'react';

import { AnimationDiv, AnimationBlock, LogoImg } from './styles';

import svgAnim from '../../static/lineW.svg';
import Logo from "../../static/Logo.svg";


const PreloaderComponent = ({ preloader, delay }) => {
  return (
      <AnimationBlock
        style={
          preloader && delay
            ? { opacity: 1 }
            : delay
            ? { opacity: 0 }
            : { display: 'none' }
        }
      >
        <AnimationDiv id="animationApproach" src={svgAnim} />
        <LogoImg src={Logo} />
      </AnimationBlock>
  );
};

export default PreloaderComponent;
